import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { EmbedPage } from "./pages/EmbedPage";
import { NIP19Page } from "./pages/NIP19Page";
import { ReaderPage } from "./pages/ReaderPage";
import { WebPage } from "./pages/WebPage";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        {/* Highlights of a plain web URL */}
        <Route path="/web/:url" element={<WebPage />} />
        {/* In-app reader for web pages (select-to-highlight) */}
        <Route path="/read/:url" element={<ReaderPage />} />
        {/* Standalone embeddable highlight card (iframes) */}
        <Route path="/embed/:nip19" element={<EmbedPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;